exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.info .ant-row.ant-form-item {\n  width: 100%;\n  margin-right: 6px;\n}\n.ant-modal-footer button.ant-btn {\n  width: 75px !important;\n}\n.ant-form-explain {\n  font-size: 12px;\n}\n.ant-form-item-with-help {\n  margin-left: 0 !important;\n}\n.responsive_modal .ant-modal-content {\n  height: 75vh !important;\n  overflow: auto !important;\n}\n", ""]);

// exports
